export const noop = () => ({})
export type CbFunction = (...args: any[]) => void
